import HttpClient from "@/common/boot/HttpClient"

const listarVueComponentesMenus = async({ commit }, payload) => {

    commit('CARREGANDO', true);

    await HttpClient.get('/app/vue-componentes-menus', payload).then(response => {
            commit('LISTAR_DADOS', response.data.data);
            return response;
        })
        .finally(() => {
            commit('CARREGANDO', false);
        });
}

const excluirVueComponentesMenus = async({ dispatch }, payload) => {
    let qtdRows = payload.length;
    for (let i = 0; i < qtdRows; ++i) {
        await excluir(payload[i]);
    }
    dispatch('listarVueComponentesMenus');
}

const excluir = async(linha) => {
    const resp = await HttpClient.delete(`/app/vue-componentes-menus/${linha.id}`).then(response => { return response; });
    return resp;
}

const salvarVueComponenteMenu = async({ commit, dispatch }, payload) => {

    commit('CARREGANDO', true);

    return await HttpClient.post('/app/vue-componentes-menus', payload).then(response => {
            dispatch('listarVueComponentesMenus');
            return response;
        })
        .finally(() => {
            commit('CARREGANDO', false);
        });
}

const recuperarVueComponenteMenu = ({ commit, state }, payload) => {

    const menu = state.items.filter(menu => menu.id === payload.id);

    if (menu.length) {
        commit('INSERIR_MENU_SELECIONADO', ...menu);
        return true;
    }

    return false;
}

const atualizarVueComponenteMenu = async({ commit, dispatch }, payload) => {
    commit('CARREGANDO', true);

    return await HttpClient.put(`/app/vue-componentes-menus/${payload.id}`, payload).then(response => {
            dispatch('listarVueComponentesMenus');
            return response;
        })
        .finally(() => {
            commit('CARREGANDO', false);
        })
}

const listarSubmodulos = async({ commit }, payload) => {
    await HttpClient.get('/app/submodulos', payload).then(response => {
        commit('LISTAR_SUBMODULOS', response.data.data);
        return response;
    });
}

const listarRotas = async({ commit }, payload) => {
    await HttpClient.get('/app/rotas', payload).then(response => {
        commit('LISTAR_ROTAS', response.data.data);
        return response;
    });
}

export {
    listarVueComponentesMenus,
    excluirVueComponentesMenus,
    salvarVueComponenteMenu,
    recuperarVueComponenteMenu,
    atualizarVueComponenteMenu,
    listarSubmodulos,
    listarRotas
}